
export default {
    name: 'LeeCountDown',
    inheritAttrs: false,
    data() {
        return {
            thesize:'',
            diffDay: '0',
            diffHou: '0',
            diffMin: '0',
            diffSec: '0',
            diff: 0
        }
    },
     watch: {
        size: {
            immediate: true,
            handler(value) {
                let types = ['s', 'm', 'l']
                let fi = types.filter(function(el) {
                    return el.indexOf(value) > -1;
                })
                if (fi.length < 1) {
                    this.thesize = "m"
                } else {
                    this.thesize = value
                }
            }
        }
    },
    created() {
        let endDate = new Date(this.endDate).getTime();
        let beginDate = new Date().getTime();
        this.diff = Math.floor((endDate - beginDate) / 1000);
        this.toDataTime()
        //定时器
        setInterval(() => {
            this.diff--;
            this.toDataTime()
        }, 1000)
    },
    methods: {
        toDataTime() {
            this.diffDay = Math.floor(this.diff / (60 * 60 * 24));
            this.diffHou = Math.floor((this.diff / (60 * 60))) - (this.diffDay * 24);
            this.diffMin = Math.floor(this.diff / (60)) - (this.diffDay * 24 * 60) - (this.diffHou * 60);
            this.diffSec = Math.floor(this.diff) - (this.diffDay * 24 * 60 * 60) - (this.diffHou * 60 * 60) - (this.diffMin * 60);
            if (this.diffDay < 10) this.diffDay = "0" + this.diffDay;
            if (this.diffHou < 10) this.diffHou = "0" + this.diffHou;
            if (this.diffMin < 10) this.diffMin = "0" + this.diffMin;
            if (this.diffSec < 10) this.diffSec = "0" + this.diffSec;
        },
        getday(xh) {
            return String(this.diffDay).substr(xh, 1)
        },
        gethou(xh) {
            return String(this.diffHou).substr(xh, 1)
        },
        getmin(xh) {
            return String(this.diffMin).substr(xh, 1)
        },
        getsec(xh) {
            return String(this.diffSec).substr(xh, 1)
        },
        lens(text) {
            return String(text).length
        }
    },
    props: {
        endDate: {
            type: String,
            default: '2021/10/01 00:00:00' //默认default
        },
        size: {
            type: String,
            default: 'm' //默认default
        },
        color: {
            type: String,
            default: '#000' //默认default
        }

    }
};
